export const GET_FILES = "GET_FILES";
export const GET_FILES_SUCCESS = "GET_FILES_SUCCESS";
export const GET_FILES_ERROR = "GET_FILES_ERROR";

export const GET_VEHICLES_UPLOADED = "GET_VEHICLES_UPLOADED";
export const GET_VEHICLES_UPLOADED_SUCCESS = "GET_VEHICLES_UPLOADED_SUCCESS";
export const GET_VEHICLES_UPLOADED_ERROR = "GET_VEHICLES_UPLOADED_ERROR";